import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class UserService {
  static getUserActivities(
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    key = "",
    sort
  ) {
    return HttpUtil.get(API_ROUTES.USERACTIVITIES.GETUSERACTIVITIES
      .replace("<pageNumber>", pageNumber)
      .replace("<pageSize>", pageSize)
      .replace(key ? "<key>" : "&key=<key>", key)
      .replace("<sort>", sort)
    );
  }

  static getUsers(
    pageNumber = 0,
    pageSize = 10,
    key = "",
    sort = "",
    fetchAll = false,
    roles = [],
    status = undefined
  ) {
    let url = API_ROUTES.USER.GET_USERS
      .replace("<pageSize>", pageSize)
      .replace("<pageNumber>", pageNumber)
      .replace("<key>", key)
      .replace("<sort>", sort)
      .replace("<fullyLoad>", true)
      .replace("<fetchAll>", fetchAll)
      .replace(roles?.length > 0 ? "<roles>" : '&roles=<roles>', roles?.length > 0 ? roles.toString() : '');

    if (status !== undefined) {
      url += `&status=${status}`;
    }

    return HttpUtil.get(url);
  }

  static createUser(payload) {
    return HttpUtil.post(API_ROUTES.USER.CREATE_USER, payload);
  }

  static updateUser(payload) {
    return HttpUtil.put(API_ROUTES.USER.UPDATE_USER, payload);
  }

  static getAllowedRoles() {
    return HttpUtil.get(API_ROUTES.USER.GET_ALLOWED_ROLES);
  }

  static getUserDetails(login) {
    return HttpUtil.get(API_ROUTES.USER.GET_USER_DETAILS.replace("<login>", login));
  }

  static activateUser(key) {
    return HttpUtil.get(API_ROUTES.USER.ACTIVATE_USER.replace("<key>", key));
  }

  static finishPasswordReset(payload) {
    return HttpUtil.post(API_ROUTES.USER.FINISH_PASSWORD_RESET, payload);
  }

  static acceptTerms() {
    return HttpUtil.post(API_ROUTES.USER.ACCEPT_TERMS);
  }

  static getUserList(payload) {
    // return HttpUtil.post('http://localhost:3131/users/list',payload);
    return HttpUtil.postForSocket(API_ROUTES.NEW_USER.GET_USER_LIST,payload);
  }
  static getSavedGroups() {
    return HttpUtil.get(API_ROUTES.USER.GET_SAVED_GROUPS);
  }

  static getUsersByGroup(payload) {
    return HttpUtil.post(API_ROUTES.USER.GET_USERS_BY_GROUP, payload);
  }
}
